import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'

import { SelectString } from '../../../../core/components/SelectString'
import { useProjectSelectlists } from '../../../../selectlists/hooks/useProjectSelectlists'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

const AANNEMER_REDENEN = ['Onvoldoende capaciteit', 'Aannemer bekend']

interface Props {
  project: HoofdleidingProject
  handleClose: () => void
}

export const Aannemer = ({ project, handleClose }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()
  const { data: selectlists } = useProjectSelectlists({
    id: project.aanvraagID,
  })
  const [reden, setReden] = useState<string | null>(null)
  const [aannemer, setAannemer] = useState<string | null>(
    project.aannemers && project.aannemers.length > 0
      ? project.aannemers[0]
      : null,
  )
  const [errors, setErrors] = useState<Record<string, boolean>>({})
  const aannemers = selectlists.aannemers ?? []

  const validate = () => {
    setErrors({
      redenError: !reden,
      aannemerError: !aannemer,
    })

    return !!reden && !!aannemer
  }

  const handleSubmitClick = () => {
    if (validate()) {
      saveEvent(
        // @ts-expect-error - aannemer and reden are checked in validate
        {
          id: project.aanvraagID,
          data: {
            aannemer,
            reden,
          },
          type: 'hoofdleiding_aannemer',
          source: 'manual',
        },
        {
          onSuccess: () => handleClose(),
        },
      )
    }
  }

  return (
    <>
      <DialogTitle>Wijzigen aannemer</DialogTitle>
      <DialogContent>
        <FormControl sx={{ width: '100%', mt: 2 }}>
          <SelectString
            options={aannemers}
            onChange={setAannemer}
            value={aannemer}
            label="Aannemer"
            error={errors.aannemerError}
          />
        </FormControl>
        <FormControl sx={{ width: '100%', mt: 2 }}>
          <SelectString
            options={AANNEMER_REDENEN}
            onChange={setReden}
            value={reden}
            label="Reden"
            error={errors.redenError}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button color="primary" onClick={handleSubmitClick}>
          Wijzigen
        </Button>
      </DialogActions>
    </>
  )
}
